import { defineManifest } from '@ndrc/app-sdk/manifest';

import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };

export const manifest = defineManifest({
  id: 'appel',
  name: 'Appel',
  description: fr.campaigns.description,
  icon: 'phone',
  color: '#1D4ED8',
  glyph: [
    // Le serre-tête, d'une oreille à l'autre.
    { d: 'M5.2 13.6V12a6.8 6.8 0 0 1 13.6 0v1.6', width: 1.7 },
    // Les deux écouteurs, pleins : ce sont eux qu'on reconnaît à 40 px dans le dock.
    { d: 'M6.9 12.4H5.4a2 2 0 0 0-2 2v1.5a2 2 0 0 0 2 2h1.5z', fill: true },
    { d: 'M17.1 12.4h1.5a2 2 0 0 1 2 2v1.5a2 2 0 0 1-2 2h-1.5z', fill: true },
    // La perche du micro, qui descend vers la bouche.
    { d: 'M18.6 17.9v1.1a2 2 0 0 1-2 2h-2.2', width: 1.5, opacity: 0.9 },
  ],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'prospection',
  permissions: {
    uses: [
      'app.records.read',
      'app.records.write',
      'contacts.read',
      'threads.read',
      'threads.write',
      'interactions.write',
      'interactions.read',
      'tasks.write',
    ],
    defines: [],
  },
  entities: {
    uses: [
      { entity: 'contacts' },
      { entity: 'threads' },
      { entity: 'interactions' },
      { entity: 'tasks' },
    ],
    owns: [
      { table: 'campaigns', scope: 'workspace', description: fr.campaigns.title },
      { table: 'queue', scope: 'workspace', description: fr.campaigns.queue },
    ],
  },
  intents: { handles: [{ intent: 'core.call.open', route: '/simulateur' }] },
  events: { emits: emitsOf(events), subscribes: [] },
  ui: {
    student: {
      defaultRoute: '/',
      routes: [
        { path: '/', title: fr.campaigns.title },
        { path: '/simulateur', title: fr.campaigns.simulator },
      ],
      layout: 'full',
    },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  contributes: {
    entityActions: [
      {
        entity: 'contacts',
        label: fr.campaigns.contactAction,
        icon: 'phone',
        intent: 'appel.campaign.contact',
        route: '/?contactId=:id',
      },
    ],
  },
  missions: { actions: ['appel.seed'], conditions: ['appel.completed'], blocks: [] },
  migrations: { schema: 'app_appel', dir: 'migrations' },
});
